module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["离托学生(" + _vm._s(_vm.studentList.length) + ")"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop
    }
  }, [_vm._h('div', {
    staticClass: "main-page"
  }, [_vm._h('ul', {
    staticClass: "list-group-item primary"
  }, [_vm._l((_vm.studentList), function(student) {
    return _vm._h('li', {
      staticClass: "list-group"
    }, [_vm._h('router-link', {
      staticClass: "group-link clearfix",
      attrs: {
        "to": {
          path: '/student/detail/' + student.studentId
        }
      }
    }, [_vm._h('span', {
      staticClass: "img-wrap small pull-left"
    }, [_vm._h('img', {
      attrs: {
        "data-original": student.imageAddress ? (student.baseAcessPath + student.imageAddress) : _vm.img_default,
        "width": "40",
        "height": "40"
      }
    })]), " ", _vm._h('span', {
      staticClass: "group-txt"
    }, [_vm._h('span', {
      staticClass: "block overhide"
    }, [_vm._h('cite', {
      staticClass: "font-16 pull-left"
    }, [_vm._s(student.studentName)]), _vm._h('i', {
      class: student.sex == '男' ? 'img-sex boy' : 'img-sex girl'
    }, [_vm._s(student.sex)])])])]), " ", _vm._h('div', {
      staticClass: "liner"
    })])
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-7075fe5f!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/student/StudentOut.vue
// module id = 214
// module chunks = 1